/** Width of the bottom action column (best score, how-to, start, back). */
export const STANDARD_STAGING_PRIMARY_WIDTH = 210
